const APP_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || '';

export const API_URLS = {
    // Users
    GET_AD_USERS: `/users`,
    GET_USER_ROLE: () => `/users/me`,
    GET_USER_ME: `users/me`,
    JWT_REFRESH_TOKEN: `/users/refresh/token`,
    GET_USER_FEEDS: () => `/users/me/feeds`,
    GUIDED_TOUR: `/users/me/guided-tour`,
    GET_RELEASE_NOTES: (version: string) => `/users/me/release-notes/${version}`,
    PUT_RELEASE_NOTES: (version: string) => `/users/me/release-notes/${version}`,
    PUT_FEEDS_STATUS: (nudgeId: string) => `/users/me/feeds/${nudgeId}/mark-read`,
    POST_LOGIN_HISTORY: () => `/users/me/login-history`,
    GET_USERS_LIST: (sortBy: string, sortOrder: string, filterBy: string[]) =>
        `/users/list?sortBy=${sortBy}&sortOrder=${sortOrder}${
            filterBy.length ? `&filterBy=${filterBy}` : ''
        }`,

    // Nudges
    GET_MOCK_ANNOUNCEMENTS_NUDGES_LIST: `/nudges/announcements`,
    GET_NUDGE_META_DATA: () => `/users/metadata`,
    GET_NUDGES_LISTS: (primaryEmail: string, page: number, pageSize: number) =>
        `/nudges/${primaryEmail}/announcements?page=${page}&pageSize=${pageSize}`,
    POST_NUDGES: `/nudges`,
    VALIDATE_NUDGE_NAME: `/nudges/validate`,
    GET_NUDGES_HISTORY: (nudgeId: string, page: number, pageSize: number) =>
        `/nudges/${nudgeId}/history?page=${page}&pageSize=${pageSize}`,
    EDIT_NUDGE_STATUS: (nudgeId: string) => `/nudges/${nudgeId}`,
    POST_NUDGES_LISTS: `/nudges/list`,
    GET_NUDGE_PREVIEW: (nudgeId: string) => `/nudges/${nudgeId}/details`,
    GET_ANNOUNCEMENTS_GLOBAL_PLACEHOLDER: '/nudges/announcement/globalPlaceHolders',

    // Token
    GET_SAS_TOKEN: '/token/SASToken',
    GET_SAS_TOKEN_WITH_EXP: '/token/sas-token/read',
    GET_NORM_DOC_TOKEN: '/doc-token/normative/read',

    // KPI
    GET_KPIS_LIST: `/kpis/list`,
    GET_SELECTED_KPI_DATA: (kpiId: string) => `/kpis/${kpiId}`,

    // Docs
    KB_GET_FOLDERS: `/content-source/documenthub/contents`,
    KB_FOLDER_CREATE: (currentSourceName: string) => `content-source/${currentSourceName}/folders`,
    KB_UPLOAD: `/content-source/documenthub/files`,
    KB_FILE: (sourceName: string, documentId: string) =>
        `/content-source/${sourceName}/documents/${documentId}`,
    KB_FOLDER: `/docs/folder`,
    // common to content source
    KB_DELETE_FOLDER: (sourceName: string) => `/content-source/${sourceName}/folder`,
    KB_METADATA: (id: string) => `/docs/metadata/${id}`,

    GET_CONTENT_SOURCES: '/content-source',
    UPDATE_CONTENT_SOURCE_NAME: (contentSource: string) => `/content-source/${contentSource}`,

    CONTENTSOURCE_SYNC_NOW: `${process.env.NEXT_PUBLIC_API_SYNC_URL}/api/httpSync`,
    CONTENTSOURCE_SYNC_SCHEDULE: (sourceName: string, uuid: string) =>
        `/content-source/${sourceName}/folders/${uuid}/sync-schedule`,
    GET_CONTENT_SOURCE_VIEW_DOCUMENT: (sourceName: string, documentId: string) =>
        `/content-source/${sourceName}/documents/${documentId}`,

    // SharePoint
    GET_SHAREPOINT_CONFIGS: '/sharepoint/sharepoint-configs',
    SHAREPOINT_SOURCES: '/sharepoint/sharepoint-sources',
    SHAREPOINT_SOURCES_DISCONNECT: (sourceId: string) =>
        `/sharepoint/sharepoint-sources/${sourceId}`,
    SHAREPOINT_CREATE_FOLDERS: (sourceId: string) =>
        `/sharepoint/sharepoint-sources/${sourceId}/folders`,
    SHAREPOINT_SOURCES_FOLDERS: (sourceId: string) =>
        `/sharepoint/sharepoint-sources/${sourceId}/filter/foldersContents/null`,
    SHAREPOINT_FOLDERS_CONTENT: (sourceId: string, parentID: string) =>
        `/sharepoint/sharepoint-sources/${sourceId}/filter/foldersContents/${parentID}`,
    SHAREPOINT_FOLDERS_DELETE: (sourceId: string, parentID: string) =>
        `/sharepoint/sharepoint-sources/${sourceId}/folders/${parentID}`,
    SHAREPOINT_ALL_FILES_COUNT: (sourceId: string) =>
        `/sharepoint/sharepoint-sources/${sourceId}/files/count`,
    SHAREPOINT_ALL_FILES_CONTENT: (sourceId: string) =>
        `/sharepoint/sharepoint-sources/${sourceId}/filter/files`,
    SHAREPOINT_DOCUMENT_VIEW: (itemId: string) =>
        `/sharepoint/sharepoint-sources/item/${itemId}/doclink`,
    SHAREPOINT_LEARNING_LOGS: (itemId: string) =>
        `/sharepoint/sharepoint-sources/item/${itemId}/logs`,
    SHAREPOINT_SITE_DRIVES: (sourceId: string) =>
        `/sharepoint/sharepoint-sources/${sourceId}/drives`,
    SHAREPOINT_DRIVES_CONTENT: (sourceId: string, driveId: string, nextLink: string) =>
        `/sharepoint/sharepoint-sources/${sourceId}/drives/${driveId}?nextLink=${nextLink}`,
    SHAREPOINT_DRIVES_FOLDER: (
        sourceId: string,
        driveId: string,
        folderId: string,
        nextLink: string
    ) =>
        `/sharepoint/sharepoint-sources/${sourceId}/drives/${driveId}/folders/${folderId}?nextLink=${nextLink}`,
    GET_SHAREPOINT_PAGES: (sourceId: string, nextLink: string) =>
        `/sharepoint/sharepoint-sources/${sourceId}/pages?nextLink=${nextLink}`,
    GET_SHAREPOINT_PAGES_LIBRARY: (sourceId: string) =>
        `/sharepoint/sharepoint-sources/${sourceId}/pageLibrary`,
    GET_SHAREPOINT_LISTS: (sourceId: string, nextLink: string) =>
        `/sharepoint/sharepoint-sources/${sourceId}/lists?nextLink=${nextLink}`,
    SHAREPOINT_EDIT_LEGAL_ENTITY_USER_GROUP: (sourceId: string, id: string) =>
        `/sharepoint/sharepoint-sources/${sourceId}/contents/${id}`,

    // DocumentHub
    GET_DOCUMENTHUB_FOLDER_LIST: `/documenthub/folders/null/contents`,
    CREATE_DOCUMENTHUB_FOLDER: `/documenthub/folders`,
    GET_DOCUMENTHUB_FOLDER_CONTENT: (parentID: string) =>
        `/documenthub/folders/${parentID}/contents`,
    DELETE_DOCUMENTHUB_FOLDER: (parentID: string) => `/documenthubdelete/folders/${parentID}`,
    DOCUMENTHUB_UPLOAD: (parentID: string) => `/documenthub/folders/${parentID}/contents`,
    DOCUMENTHUB_VALIDATE_FILE: (parentID: string) => `/documenthub/validateDocument/${parentID}`,
    GET_DOWNLOADED_DOCUMENT: (id: string) => `/documenthub/contents/${id}/link`,
    DELETE_PATCH_DOCUMENT: (id: string) => `/documenthub/contents/${id}`,
    DOCUMENTHUB_LEARNING_LOGS: (itemId: string) => `/documenthub/contents/${itemId}/logs`,

    CONNECT_SHAREPOINT: (sourceName: string) => `/content-source/${sourceName}`,
    GET_SHAREPOINT_DOCUMENT_LIBRARIES: (sourceName: string, siteURL: string) =>
        `/content-source/${sourceName}/documentLibrary?siteURL=${siteURL}`,
    GET_LIBRARY_CONTENT: (sourceName: string, siteId: string, driveId: string) =>
        `/content-source/${sourceName}/libraryContent?siteId=${siteId}&driveId=${driveId}`,
    GET_SHAREPOINT_FOLDER_CONTENT: (
        sourceName: string,
        folderId: string,
        driveId: string,
        nextLink: string
    ) =>
        `/content-source/${sourceName}/folderContent?folderId=${folderId}&driveId=${driveId}&nextLink=${nextLink}`,
    SHAREPOINT_FILE_UPLOAD: (sourceId: string) =>
        `/sharepoint/sharepoint-sources/${sourceId}/contents`,
    SHAREPOINT_FILE_DELETE: (documentId: string) =>
        `/sharepoint/sharepoint-sources/item/${documentId}`,
    SHAREPOINT_SYNC_NOW: (sourceId: string, folderId: string) =>
        `/sharepoint/sharepoint-sources/${sourceId}/folders/${folderId}/sync`,
    SHAREPOINT_SYNC_SCHEDULE: (sourceId: string, folderId: string) =>
        `/sharepoint/sharepoint-sources/${sourceId}/folders/${folderId}/syncschedule`,
    SHAREPOINT_RE_LEARN: (sourceId: string, itemId: string) =>
        `/sharepoint/sharepoint-sources/${sourceId}/item/${itemId}/sync`,
    // Reports
    EXPORT_REPORTS_DATA: (format: string) => `/reports/export/${format}`,
    FETCH_UESR_ACTIVITY_REPORT: '/reports/activities',
    GET_USER_QUERY_LOG: (startDate: string, endDate: string) =>
        `/reports/query-analytics?startDate=${startDate}&endDate=${endDate}`,
    GET_REPORTS_DETAILS: '/reports/query-logs',
    GET_ROUTED_SERVICE_SUMMARY: `/reports/routed-service-summary`,
    GET_QUESTION_DETAILS: (dialogId: string, detail: string) =>
        `/reports/conversation/${dialogId}/details/${detail}`,
    GET_CONTENT_SOURCE_FOLDERS: (sourceName: string) => `/content-source/${sourceName}/folders`,
    GET_CONTENT_SOURCE_FOLDER_CONTENT: (
        sourceName: string,
        parentId: string,
        sortField: string,
        sortOrder: string
    ) =>
        `/content-source/${sourceName}/folders?parentId=${parentId}&sortField=${sortField}&sortOrder=${sortOrder}`,
    CREATE_CONTENT_SOURCE_FOLDERS: (sourceName: string) => `/content-source/${sourceName}/folders`,
    GET_REPORTS_SEARCH_ITEMS: (searchItemName: string, searchValueParam: string) =>
        `/reports/search-items/${searchItemName}?searchValue=${searchValueParam}`,
    GET_SYNC_HISTORY_LIST: (sourceName: string, id: string) =>
        `/content-source/${sourceName}/documents/${id}/sync-history`,
    GET_FILTER_DATA: `/reports/filter`,
    // Download llm docs
};

export const APP_BASE_API_URL = APP_BASE_URL;
